import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Card,
  CardContent,
  Typography,
  Box,
  Grid
} from '@mui/material';
import {
  Api as ApiIcon,
  QrCode as QrCodeIcon
} from '@mui/icons-material';

const ConnectionTypeModal = ({ open, onClose, onSelect }) => {
  const handleOptionSelect = (type) => {
    onSelect(type);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Typography variant="h5" component="div" align="center">
          Escolha o Tipo de Conexão WhatsApp
        </Typography>
      </DialogTitle>
      <DialogContent
        sx={{
          p: 3,
          minWidth: 500
        }}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Card
              sx={{
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                border: '2px solid transparent',
                '&:hover': {
                  borderColor: 'primary.main',
                  transform: 'translateY(-2px)',
                  boxShadow: 4
                }
              }}
              onClick={() => handleOptionSelect('official')}
            >
              <CardContent sx={{ textAlign: 'center', p: 3 }}>
                <ApiIcon
                  sx={{
                    fontSize: 48,
                    mb: 2,
                    color: 'primary.main'
                  }}
                />
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 'bold',
                    mb: 1
                  }}
                >
                  API Oficial WhatsApp
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: 'text.secondary',
                    textAlign: 'center',
                    mb: 2
                  }}
                >
                  Conexão oficial através da API do WhatsApp Business
                </Typography>
                <Box sx={{ textAlign: 'left' }}>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    ✓ Maior estabilidade
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    ✓ Suporte oficial
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    ✓ Recursos avançados
                  </Typography>
                  <Typography variant="body2">
                    ✓ Melhor para empresas
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card
              sx={{
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                border: '2px solid transparent',
                '&:hover': {
                  borderColor: 'primary.main',
                  transform: 'translateY(-2px)',
                  boxShadow: 4
                }
              }}
              onClick={() => handleOptionSelect('unofficial')}
            >
              <CardContent sx={{ textAlign: 'center', p: 3 }}>
                <QrCodeIcon
                  sx={{
                    fontSize: 48,
                    mb: 2,
                    color: 'primary.main'
                  }}
                />
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 'bold',
                    mb: 1
                  }}
                >
                  Conexão Não Oficial
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: 'text.secondary',
                    textAlign: 'center',
                    mb: 2
                  }}
                >
                  Conexão através de QR Code (WhatsApp Web)
                </Typography>
                <Box sx={{ textAlign: 'left' }}>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    ✓ Configuração rápida
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    ✓ Sem custos adicionais
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    ✓ Ideal para testes
                  </Typography>
                  <Typography variant="body2">
                    ✓ Fácil implementação
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ p: 2, justifyContent: 'center' }}>
        <Button onClick={onClose} variant="outlined">
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConnectionTypeModal;
